import { render } from "./MRoom1View.vue?vue&type=template&id=f3886bee"
import script from "./MRoom1View.vue?vue&type=script&lang=js"
export * from "./MRoom1View.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__